import { render } from "./WorkflowSer.vue?vue&type=template&id=64f7102d"
import script from "./WorkflowSer.vue?vue&type=script&lang=js"
export * from "./WorkflowSer.vue?vue&type=script&lang=js"

import "./WorkflowSer.vue?vue&type=style&index=0&id=64f7102d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__